/** Общие паузы и пороги окон Platform: одно значение на одно смысловое место, а не копия числа в каждом окне. */

/** Опрос запусков замеров и правил, пока запуск идёт: ход и итог видны без «Обновить». */
export const RUN_POLL_MS = 3000

/** Пауза после последнего символа в строке поиска, прежде чем уходить с запросом. */
export const SEARCH_DEBOUNCE_MS = 300
